/// <reference path="../../Common/Helpers/GridEditorBase.ts" />

namespace TabAurous.HR {
    import fld = AttendanceDetailsRow.Fields;
    @Serenity.Decorators.registerClass()
    export class AttendanceDetailsEditor extends _Ext.GridEditorBase<AttendanceDetailsRow> {
        protected getColumnsKey() { return "HR.AttendanceDetails"; }
        protected getLocalTextPrefix() { return AttendanceDetailsRow.localTextPrefix; }

        constructor(container: JQuery) {
            super(container);

            this.slickGrid.onRender.subscribe(() => {
                this.SetInlineLookupEditor();
            });
        }
        public getColumns() {

            var columns = super.getColumns();

            //columns.unshift({
            //    field: 'Delete Row',
            //    name: '',
            //    format: ctx => '<a class="inline-action delete-row" title="delete">' +
            //        '<i class="fa fa-trash-o text-red"></i></a>',
            //    width: 24,
            //    minWidth: 24,
            //    maxWidth: 24
            //});

            var Abs = Q.first(columns, x => x.field === fld.Absent);
            Abs.referencedFields = [fld.Absent];
            Abs.format = ctx => {
                var width = (ctx.column.width) as number - 10;
                return '<input type="hidden" style="text-align: right; width:' + width + 'px;" id="Abs' + ctx.row + '" title="Absent" />';
            };

            var Pre = Q.first(columns, x => x.field === fld.Present);
            Pre.referencedFields = [fld.Present];
            Pre.format = ctx => {
                var width = (ctx.column.width) as number - 10;
                return '<input type="hidden" style="text-align: right; width:' + width + 'px;" id="Pre' + ctx.row + '" title="Present" />';
            };

            var Lea = Q.first(columns, x => x.field === fld.OnLeave);
            Lea.referencedFields = [fld.OnLeave];
            Lea.format = ctx => {
                var width = (ctx.column.width) as number - 10;
                return '<input type="hidden" style="text-align: right; width:' + width + 'px;" id="Lea' + ctx.row + '" title="OnLeave" />';
            };

            var Hlf = Q.first(columns, x => x.field === fld.HalfDay);
            Hlf.referencedFields = [fld.HalfDay];
            Hlf.format = ctx => {
                var width = (ctx.column.width) as number - 10;
                return '<input type="hidden" style="text-align: right; width:' + width + 'px;" id="Hlf' + ctx.row + '" title="HalfDay" />';
            };

            return columns;
        }

        public SetInlineLookupEditor() {
            // course of all the lines present in the grid
            var Items = this.view.getItems();
            if (Items.length > 0)
                for (let Item in Items) {
                    this.AbsCheckbox(Item, Items);
                    this.PreCheckbox(Item, Items);
                    //this.LeaCheckbox(Item, Items);
                    //this.HlfCheckbox(Item, Items);
                }
        }

        AbsCheckbox(RowIndex: string, Items: any[]) {

            let select = $("#Abs" + RowIndex);
            if (!select.hasClass("check-box")) {
                let Editor = new Serenity.BooleanEditor($("#Abs" + RowIndex))
                if (this.isReadOnly == true) {
                    q.showAndDisableField(Editor);
                }
                else
                    q.showAndEnableField(Editor);
                Editor.value = Q.toId(Items[RowIndex].Absent);
                Editor.changeSelect2(e => {
                    var id = this.id(Items[RowIndex]);
                    this.view.refresh();
                    Items[RowIndex].Absent = Editor.value;
                    this.view.updateItem(id, Items[RowIndex]);
                });
            }

        }

        PreCheckbox(RowIndex: string, Items: any[]) {

            let select = $("#Pre" + RowIndex);
            if (!select.hasClass("s-YesNoEditor")) {
                let Editor = new _Ext.YesNoEditor($(select))
                if (this.isReadOnly == true) {
                    q.showAndDisableField(Editor);
                }
                else
                    q.showAndEnableField(Editor);
                Editor.value = Q.toId(Items[RowIndex].Present);
                Editor.changeSelect2(e => {
                    var id = this.id(Items[RowIndex]);
                    this.view.refresh();
                    this.view.updateItem(id, Items[RowIndex]);
                });
            }

        }

        LeaCheckbox(RowIndex: string, Items: any[]) {

            let select = $("#Lea" + RowIndex);

            let Editor = new _Ext.YesNoEditor($(select))
            if (this.isReadOnly == true) {
                q.showAndDisableField(Editor);
            }
            else
                q.showAndEnableField(Editor);
            Editor.value = Q.toId(Items[RowIndex].OnLeave);
            Editor.changeSelect2(e => {
                var id = this.id(Items[RowIndex]);
                this.view.refresh();
                this.view.updateItem(id, Items[RowIndex]);
            });

        }

        HlfCheckbox(RowIndex: string, Items: any[]) {

            let select = $("#Hlf" + RowIndex);

            let Editor = new Serenity.BooleanEditor($(select))
            if (this.isReadOnly == true) {
                q.showAndDisableField(Editor);
            }
            else
                q.showAndEnableField(Editor);
            Editor.value = Q.toId(Items[RowIndex].HalfDay);
            Editor.changeSelect2(e => {
                var id = this.id(Items[RowIndex]);
                this.view.refresh();
                this.view.updateItem(id, Items[RowIndex]);
            });

        }




        //protected onClick(e: JQueryEventObject, row: number, cell: number) {
        //    super.onClick(e, row, cell);

        //    if (e.isDefaultPrevented())
        //        return;

        //    var item = this.itemAt(row);
        //    var id = this.id(item);
        //    var target = $(e.target);
        //    var p = $(e.target.parentNode);
        //    item.Absent = false;
        //    item.OnLeave = false;
        //    item.Present = false;
        //    item.HalfDay = false;
        //    let abs = $("#Abs" + row);
        //    if (target..('l5 r5')) {
        //        //if (item.OnLeave == true) {
        //        //    item.OnLeave = false;
        //        //    this.view.updateItem(id, item);
        //        //    this.view.refresh();
        //        //}
        //        //else {
        //            item.OnLeave = true;

        //        //}
        //    }else if (p.hasClass('l4 r4')) {
        //        //if (item.HalfDay == true)
        //        //    item.HalfDay = false;
        //        //else
        //            item.HalfDay = true; 
        //    } else if (p.hasClass('l3 r3')) {
        //        //if (item.Absent == true)
        //        //    item.Absent = false;
        //        //else
        //            item.Absent = true; 
        //    } else if (p.hasClass('l2 r2')) {
        //        //if (item.Present == true)
        //        //    item.Present= false;
        //        //else
        //            item.Present = true; 
        //    }

        //    this.view.updateItem(id, item);
        //    this.view.refresh();
        //    if (target.hasClass('check-box no-float readonly') || target.hasClass('check-box no-float readonly checked'))
        //        target.removeClass('readonly')

             

        //    if (target.parent().hasClass('inline-action'))
        //        target = target.parent();

        //    if (target.hasClass('inline-action')) {
        //        e.preventDefault();

        //        if (target.hasClass('delete-row')) {
        //            Q.confirm('Delete record?', () => {

        //                this.view.deleteItem(id);
        //                this.view.refresh();
        //            });
        //        }
        //        if (target.hasClass('edit numeric')) {
        //            super.onClick(e, row, cell);
        //        }
        //    }
        //}


        protected getButtons() {
            var buttons = super.getButtons();
            buttons = buttons.filter(x => x.cssClass != "add-button");
            buttons.pop();
            buttons.push({
                title: "Select All Employees",
                icon:"fa-users",
                hotkey: "alt+i",
                hint: 'alt+i',
                onClick: () => {
                    Master.EmployeeMasterService.GetActiveEmployees({},
                        response => {
                            if (response.Entities != null && response.Entities.length > 0) {
                                for (let employee of response.Entities) {
                                    var newemp: AttendanceDetailsRow = {
                                        EmployeeId: employee.EmployeeId,
                                        EmployeeName: employee.EmployeeName,
                                        EmployeeCode: employee.EmployeeCode,
                                    }
                                    newemp[this.getIdProperty()] = "`" + this.nextId++;

                                    this.view.addItem(newemp);
                                }
                            }
                        }, { async: false })
                }
            })
            return buttons;
        }
       
    }
}